import React from "react";
import styled from "styled-components";
import { colors } from "src/styles";
import { ID, LocationForTable } from "src/types";
// import { formatTimezoneToShort } from "src/utils/time";

export interface LocationsTable {
  isLoading: boolean;
  headers: string[];
  data: LocationForTable[];
  onRowClick: (id: ID, label: string) => void;
}

export const LocationsTable = ({ isLoading, headers, data, onRowClick }: LocationsTable) => {
  if (isLoading) {
    return <EmptyRow>Loading...</EmptyRow>;
  }

  if (!data.length) {
    return <EmptyRow>No Locations assigned</EmptyRow>;
  }

  return (
    <TableWrapper>
      <TableHeader>
        {headers.map((header) => (
          <span key={header}>{header}</span>
        ))}
      </TableHeader>
      {data.map(({ id, label, address, clientName }: LocationForTable) => {
        return (
          <TableRow key={id} onClick={() => onRowClick(id, label)}>
            <IdPill>{id.toString() ?? "N/A"}</IdPill>
            <NameCell>{label || "N/A"}</NameCell>
            <MutedCell>{address || <ItalicDash>N/A</ItalicDash>}</MutedCell>
            {clientName && <MutedCell>{clientName}</MutedCell>}
          </TableRow>
        );
      })}
    </TableWrapper>
  );
};

const TableWrapper = styled.div`
  overflow-x: auto;
`;

const TableGridBase = styled.div`
  display: grid;
  grid-template-columns: 110px minmax(220px, 1fr) minmax(360px, 1.3fr);
  gap: 8px;
  align-items: center;
  min-width: 760px;
`;

const TableHeader = styled(TableGridBase)`
  padding: 12px 16px;
  color: ${colors.grey.dark6};
  border-bottom: 1px solid ${colors.grey.light3};
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-weight: 600;
`;

const TableRow = styled(TableGridBase)`
  padding: 14px 16px;
  border-top: 1px solid ${colors.grey.light3};
  cursor: pointer;

  &:hover {
    background: ${colors.grey.light6};
  }
`;

const EmptyRow = styled.div`
  padding: 20px 16px;
  color: ${colors.grey.dark6};
  font-size: 13px;
`;

const IdPill = styled.span`
  border: 1px solid ${colors.grey.light4};
  background: ${colors.grey.light6};
  font-size: 11px;
  font-weight: 700;
  color: ${colors.black.light1};
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 4px 8px;
  width: fit-content;
`;

const NameCell = styled.span`
  font-size: 13px;
  color: ${colors.black.dark1};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const MutedCell = styled.span`
  font-size: 12px;
  color: ${colors.grey.dark6};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ItalicDash = styled.span`
  color: ${colors.grey.dark7};
  font-style: italic;
`;
